import {
  Typography,
  Divider,
  List,
  ListItem,
  ListItemText,
  Link,
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from '@mui/material';
import { Col } from 'shared/ui/Col';

export const IncreaseViewsContent = () => {
  return (
    <Col spacing={7} sx={{ maxHeight: '80vh', overflowY: 'auto' }}>
      <Typography variant="headerM">
        📢 Продвижение через поднятие в списках
      </Typography>

      <Typography>
        Продвижение в <strong>Nedvex App</strong> — это стратегический
        инструмент для роста продаж и усиления позиции на рынке.
      </Typography>

      <Col spacing={4}>
        <Typography variant="accentM">📈 Что даёт продвижение:</Typography>

        <List>
          <ListItem disablePadding>
            <ListItemText primary="▫️ Рост просмотров на 20–30% — уже в первую неделю, по данным наших первых клиентов" />
          </ListItem>
          <ListItem disablePadding>
            <ListItemText primary="▫️ Увеличение количества показов на первых местах в наиболее заметных разделах: «Основной список», «Новинки», «Акции», результаты фильтрации" />
          </ListItem>
          <ListItem disablePadding>
            <ListItemText primary="▫️ Увеличение переходов на карточку объекта и числа обращений от агентов" />
          </ListItem>
        </List>
      </Col>

      <Col spacing={6}>
        <Typography variant="accentM">
          Тарифы на продвижение в Nedvex App
        </Typography>

        <Typography>
          Цена указана за один объект, зависит от срока и количества объектов
        </Typography>

        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>
                  <strong>Срок продвижения</strong>
                </TableCell>
                <TableCell>
                  <strong>1 объект</strong>
                </TableCell>
                <TableCell>
                  <strong>2 объекта</strong>{' '}
                  <Typography>(экономия 10%)</Typography>
                </TableCell>
                <TableCell>
                  <strong>3 объекта</strong>{' '}
                  <Typography>(экономия 20%)</Typography>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell>7 дней</TableCell>
                <TableCell>2 500 ₽</TableCell>
                <TableCell>2 250 ₽ за объект</TableCell>
                <TableCell>2 000 ₽ за объект</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>14 дней</TableCell>
                <TableCell>4 500 ₽</TableCell>
                <TableCell>4 050 ₽ за объект</TableCell>
                <TableCell>3 600 ₽ за объект</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>30 дней</TableCell>
                <TableCell>7 500 ₽</TableCell>
                <TableCell>6 750 ₽ за объект</TableCell>
                <TableCell>6 000 ₽ за объект</TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>

        <Col spacing={6} mt={3}>
          <Typography variant="headerXS">
            📌 Пример расчёта для 3 объектов на 14 дней:
          </Typography>
          <Typography mt={1}>
            3 объекта × 3 600 ₽ = <strong>10 800 ₽</strong>{' '}
            <Typography component="span">
              (вместо 13 500 ₽ без скидки)
            </Typography>
          </Typography>
        </Col>
      </Col>

      <Typography>
        Для понимания как это работает: у нас есть определенный перечень
        объектов на продвижении. И чтобы одни и те же объекты не выбивались
        постоянно на первых местах в списках, мы меняем их очередность раз в
        час.
        <br />
        То есть, к примеру, ваш объект может в 13:30 выводиться на первом месте,
        а через час — уже на третьем и т.д.
      </Typography>

      <Typography>
        В целом продвижение нацелено на то, чтобы ваш объект чаще выводился в
        топе общего списка и при фильтрации.
      </Typography>

      <Typography>
        Количество просмотров и другую аналитику можно увидеть в личном кабинете
        застройщика:{' '}
        <Link
          href="http://nedvex.pro"
          target="_blank"
          rel="noopener noreferrer"
        >
          nedvex.pro
        </Link>
      </Typography>

      <Divider sx={{ my: 3 }} />

      <Typography variant="headerXS">Как подключить?</Typography>

      <Typography>1. Свяжитесь с одним из менеджеров Nedvex:</Typography>

      <List dense sx={{ pl: 2 }}>
        <ListItem disablePadding>
          <ListItemText
            primary={
              <>
                • Олег – WA:{' '}
                <Link
                  href="https://wa.me/375295322767"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  +375295322767
                </Link>
                , TG:{' '}
                <Link
                  href="https://t.me/yakuta_oleg"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  @yakuta_oleg
                </Link>
              </>
            }
          />
        </ListItem>
        <ListItem disablePadding>
          <ListItemText
            primary={
              <>
                • Контент отдел – моб/WA:{' '}
                <Link
                  href="https://wa.me/79683000112"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  +7 968 300-01-12
                </Link>
                , TG:{' '}
                <Link
                  href="https://t.me/Nedvex_content_manager"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  @Nedvex_content_manager
                </Link>
              </>
            }
          />
        </ListItem>
      </List>

      <Typography>2. Выберите тариф.</Typography>
      <Typography>
        3. Оплатите счёт — продвижение будет запущено в тот же день.
      </Typography>
    </Col>
  );
};
